﻿import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { LoginComponent } from '../login/login.component';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as crypto from 'crypto-js';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { APIConstants } from '../../../../_config/restapis';
import { formatDate, DatePipe } from '@angular/common';
import { MustMatch } from '../../../../_helpers/must-match-validator';
import { FileSelectDirective, FileUploader } from 'ng2-file-upload';
import * as CryptoJS from 'crypto-js';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

import { MatDialog, MatTable } from '@angular/material';

import { MatIconModule } from '@angular/material/icon'

import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/of';
import * as moment from 'moment-timezone';
import { Location } from '@angular/common';

export interface Element {
  details: string;
  position: number;
  existing_detail: string;
  existing_details: string;
  //  request_modification: string;
}


export interface PeriodicElementfile {
  doctype: string;
  olddoc: string;
  newdoc: string;

  filename: any;
  newfilename: any;

  filetype: any;
  fileExists: any;
  fileExists1: any;
}

export interface rejectlist {
  value: string;
  viewValue: string;
}

export interface modiflist {
  value: string;
  viewValue: string;
}
export interface selectedCountry {
  id: string;
  name: string;
}

export interface selectedState {
  id: string;
  name: string;
  country_id: string
}
export interface selectedCity {
  id: string;
  name: string;
  state_id: string;
}




@Component({
  selector: 'app-entity-editlog',
  templateUrl: './entity-editlog.component.html',
  styleUrls: ['./entity-editlog.component.css']
})
export class EntityEditLogComponent implements OnInit {
  ELEMENT_DATA: Element[] = [
    { position: 1, details: 'Entity ID', existing_detail: '', existing_details: '' },
    { position: 2, details: 'Creator', existing_detail: '', existing_details: '' },
    { position: 3, details: 'Entity Classification', existing_detail: '', existing_details: '' },
    { position: 4, details: 'Organization Name', existing_detail: '', existing_details: '' },
    { position: 5, details: 'Industry Category', existing_detail: '', existing_details: '' },
    { position: 6, details: 'POI', existing_detail: '', existing_details: '' },
    { position: 7, details: 'Status', existing_detail: '', existing_details: '' },
    { position: 8, details: 'createTS', existing_detail: '', existing_details: '' },
    { position: 9, details: 'ApprovedTs', existing_detail: '', existing_details: '' },
    { position: 10, details: 'UpdateTS', existing_detail: '', existing_details: '' },
    { position: 11, details: 'Service Provider', existing_detail: '', existing_details: '' },
    { position: 12, details: 'Blacklisted', existing_detail: '', existing_details: '' },
    { position: 13, details: 'Industry Type', existing_detail: '', existing_details: '' },
    { position: 14, details: 'Industry Sector', existing_detail: '', existing_details: '' },
    { position: 15, details: 'Authorized Signature Name', existing_detail: '', existing_details: '' },
    { position: 16, details: 'Registered Email ID', existing_detail: '', existing_details: '' },
    { position: 17, details: 'Registered Mobile Number', existing_detail: '', existing_details: '' },
    { position: 18, details: 'Complete Address', existing_detail: '', existing_details: '' },
    { position: 19, details: 'RegAddress1', existing_detail: '', existing_details: '' },
    { position: 20, details: 'RegAddress2', existing_detail: '', existing_details: '' },
    { position: 21, details: 'Landmark', existing_detail: '', existing_details: '' },
    { position: 22, details: 'Country', existing_detail: '', existing_details: '' },
    { position: 23, details: 'State', existing_detail: '', existing_details: '' },
    { position: 24, details: 'City', existing_detail: '', existing_details: '' },
    { position: 25, details: 'PINCode', existing_detail: '', existing_details: '' },
    { position: 26, details: 'POI Document Type', existing_detail: '', existing_details: '' },
    { position: 27, details: 'POA Document Type', existing_detail: '', existing_details: '' },
    { position: 28, details: 'GST ID', existing_detail: '', existing_details: '' },
    { position: 29, details: 'Other Document Name', existing_detail: '', existing_details: '' },
    { position: 30, details: 'Registration Status', existing_detail: '', existing_details: '' },
    { position: 31, details: 'TM Type', existing_detail: '', existing_details: '' },
    { position: 32, details: 'Rejected Date', existing_detail: '', existing_details: '' },
    { position: 33, details: 'Modification Requested ON', existing_detail: '', existing_details: '' },
  ];




  ELEMENT_DATA_FILE: PeriodicElementfile[] = [
    { doctype: "POI", olddoc: "PAN Document", newdoc: "PAN Document", filename: '', newfilename: '', filetype: 'POI', fileExists: true, fileExists1: true },
    { doctype: "POA", olddoc: 'POA Document', newdoc: "POA Document", filename: '', newfilename: '', filetype: 'POA', fileExists: true, fileExists1: true },
    { doctype: "GST Certificate", olddoc: 'GST Certificate', newdoc: "GST Document", filename: '', newfilename: '', filetype: "GST", fileExists: true, fileExists1: true },
    { doctype: "SEBI Certificate", olddoc: 'SEBI Certificate', newdoc: "SEBI Document", filename: '', newfilename: '', filetype: "SEBI", fileExists: true, fileExists1: true },
    { doctype: "Other Document1", olddoc: 'Other Document1', newdoc: "Other Document1", filename: '', newfilename: '', filetype: "OTHER", fileExists: true, fileExists1: true },
    { doctype: "Other Document2", olddoc: 'Other Document2', newdoc: "Other Document2", filename: '', newfilename: '', filetype: "OTHER1", fileExists: true, fileExists1: true },
  ];



  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;
  entityRefNo: any;
  SR_URN: any
  response: any;
  reqStatus: any
  EntityStatus: any;
  disableForm: boolean;
  showRejectReason: boolean = false;
  showRemarks: boolean = false;
  showModifyReason: boolean = false;
  poi_type: any;
  poa_type: any;
  poafilename: any;
  poifilename: any;
  approveFlag: boolean = false
  // rejectFlag: boolean = false
  // modifyFlag: boolean = false  




  constructor(private fb: FormBuilder,
    //private es: APILoginService,
    private es: APIEntityService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    public dialog: MatDialog,
    private _location: Location,
    private router: Router) {
    this.getEntityDetails();
  }//end of constructor

  displayedColumns: string[] = ['position', 'details', 'existing_detail', 'existing_details'];
  //dataSource1 = this.ELEMENT_DATA;
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  dataSource1 = new ExampleDataSource(this.ELEMENT_DATA);

  update(el: Element, comment: string) {
    if (comment == null) { return; }
    // copy and mutate
    const copy = this.dataSource1.data().slice()
    //el.request_modification = comment;
    this.dataSource1.update(copy);
  }




  displayedColumnsfile: string[] = ['doctype', 'olddoc', 'newdoc'];
  // displayedColumnsfile1: string[] = ['doctype', 'olddoc', 'newdoc'];
  dataSourcefile = this.ELEMENT_DATA_FILE;

  rejectlistitems: rejectlist[] = [
    { value: 'Reject Reason 1', viewValue: 'Reject Reason 1' },
    { value: 'Reject Reason 2', viewValue: 'Reject Reason 2' },
    { value: 'Reject Reason 3', viewValue: 'Reject Reason 3' },
    { value: 'Reject Reason 4', viewValue: 'Reject Reason 4' },
    { value: 'Reject Reason 5', viewValue: 'Reject Reason 5' },
    { value: 'Reject Reason 6', viewValue: 'Reject Reason 6' },


  ];

  modiflistitems: modiflist[] = [
    { value: 'Modify Reason 1', viewValue: 'Modify Reason 1' },
    { value: 'Modify Reason 2', viewValue: 'Modify Reason 2' },
    { value: 'Modify Reason 3', viewValue: 'Modify Reason 3' },
    { value: 'Modify Reason 4', viewValue: 'Modify Reason 4' },
    { value: 'Modify Reason 5', viewValue: 'Modify Reason 5' },
    { value: 'Modify Reason 6', viewValue: 'Modify Reason 6' },

  ];
  selectedCountrylist: selectedCountry[] = [
    { id: '1', name: 'India' }
  ];

  //states
  selectedStatelist: selectedState[] = [
    { id: '1', country_id: '1', name: 'Andhra Pradesh' },
    { id: '2', country_id: '1', name: 'Telagana' },
    { id: '3', country_id: '1', name: 'Karnataka' },
  ];


  selectedCitylist: selectedCity[] = [
    { id: '1', state_id: '1', name: 'Anantapur' },
    { id: '2', state_id: '1', name: 'Chittoor' },
    { id: '3', state_id: '2', name: 'Hyderabad' },
    { id: '4', state_id: '2', name: 'Kariminagar' },
    { id: '5', state_id: '3', name: 'Bengalore Urban  ' },
    { id: '6', state_id: '3', name: 'Bengalore Rural' }
  ];

  entityForm: FormGroup;
  selectedValue: String;
  name: string;
  position: number;
  weight: number;
  symbol: string;
  modiflist: any;
  rejectlist: any;
  reqtype: any;


  get f() { return this.entityForm.controls; }


  ngOnInit() {

    this.entityForm = this.fb.group({
      request_type: [''],
      urn_no: [''],
      creation_timestamp: ['',],
      assigned_timestamp: ['',],
      paymen_applicable: ['',],

      remarks: ['', [Validators.required, Validators.maxLength(200), Validators.minLength(10)]],
      rej_reason: ['',],
      modification_reason: ['',],


    });//end of entityForm



    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  } // oninit

  backClicked() {
    console.log("clickedddddddddddd");
    this._location.back();
  }


  getSubstring(filename) {
    return filename.substring(filename.indexOf('.') + 1)
  }
  //For PAN Decryption

  Pan(datas) {
    const key = '18bcd0b950de300fb873788958fde988fec9b478a936a3061575b16f79977d5b';
    const IV = '2e11075e7b38fa20e192bc7089ccf32b';

    const decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Hex.parse(datas) }, CryptoJS.enc.Hex.parse(key), {
      iv: CryptoJS.enc.Hex.parse(IV),
      mode: CryptoJS.mode.CBC
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  getEntityDetails() {
    var varEClass = {
      'G': 'Government',
      'P': 'Private Ltd Company',
      'S': 'SEBI',
      'U': 'Public Limited Company',
      'O1': 'Individual',
      'O2': 'Sole Proprietorship',
      'O3': 'Partnership Firm',
      'O4': 'Limited Liability Partnership',
      'O5': 'Trust, Association, Society, Club',
      'O': 'Others'
    }

    var eclass = {
      'PE': 'Principal Entity',
      'TM': 'Telemarketer',
      'TA': 'Telemarketer Aggregator'
    }
    this._route.params.subscribe((params) => {
      this.entityRefNo = params['urn'];
      
      console.log("THis line called")

    })
    var data = {
      SR_URN: this.entityRefNo,
      Collection: "Entity"
      //Role:"Entity",


    }
    this.es.getEditLog(data)
      .subscribe(r => {
        console.log("getEditLog ", r)
        this.SR_URN = r.SR_URN
        this.response = r;
        if (r.message != "Not found") {
          if(r.RecordID != r.SR_URN)
          this.reqtype = "serviceLogs"
          else
          this.reqtype = "newRegistration"


          if (r.OldValue.Entity_POI_Doc) {

            this.ELEMENT_DATA_FILE[0]['filename'] = r.OldValue.Entity_POI_Doc
            this.ELEMENT_DATA_FILE[0]['fileExists'] = true

          }
          else {
            this.ELEMENT_DATA_FILE[0]['filename'] = ""
            this.ELEMENT_DATA_FILE[0]['fileExists'] = false
          }

          if (r.OldValue.Entity_POA_Doc) {
            this.ELEMENT_DATA_FILE[1]['filename'] = r.OldValue.Entity_POA_Doc
            this.ELEMENT_DATA_FILE[1]['fileExists'] = true

          }
          else {
            this.ELEMENT_DATA_FILE[1]['filename'] = ""
            this.ELEMENT_DATA_FILE[1]['fileExists'] = false
          }


          if (r.OldValue.Entity_GST_Doc) {
            this.ELEMENT_DATA_FILE[2]['filename'] = r.OldValue.Entity_GST_Doc
            this.ELEMENT_DATA_FILE[2]['fileExists'] = true

          }
          else {
            this.ELEMENT_DATA_FILE[2]['filename'] = ""
            this.ELEMENT_DATA_FILE[2]['fileExists'] = false
          }


          if (r.OldValue.Entity_SEBI_Doc) {
            this.ELEMENT_DATA_FILE[3]['filename'] = r.OldValue.Entity_SEBI_Doc
            this.ELEMENT_DATA_FILE[3]['fileExists'] = true

          }
          else {
            this.ELEMENT_DATA_FILE[3]['filename'] = ""
            this.ELEMENT_DATA_FILE[3]['fileExists'] = false
          }


          if (r.OldValue.Entity_Other_Doc) {
            this.ELEMENT_DATA_FILE[4]['filename'] = r.OldValue.Entity_Other_Doc
            this.ELEMENT_DATA_FILE[4]['fileExists'] = true

          }
          else {
            this.ELEMENT_DATA_FILE[4]['filename'] = ""
            this.ELEMENT_DATA_FILE[4]['fileExists'] = false
          }


          if (r.OldValue.Entity_Other_Doc1) {
            this.ELEMENT_DATA_FILE[5]['filename'] = r.OldValue.Entity_Other_Doc1
            this.ELEMENT_DATA_FILE[5]['fileExists'] = true

          }
          else {
            this.ELEMENT_DATA_FILE[5]['filename'] = ""
            this.ELEMENT_DATA_FILE[5]['fileExists'] = false
          }


          if (r.NewValue.Entity_POI_Doc != null && r.NewValue.Entity_POI_Doc != "") {
            this.ELEMENT_DATA_FILE[0]['newfilename'] = r.NewValue.Entity_POI_Doc
            this.ELEMENT_DATA_FILE[0]['fileExists1'] = true

          }
          else {
            this.ELEMENT_DATA_FILE[0]['newfilename'] = ""
            this.ELEMENT_DATA_FILE[0]['fileExists1'] = false

          }


          if (r.NewValue.Entity_POA_Doc != null && r.NewValue.Entity_POA_Doc != "") {
            this.ELEMENT_DATA_FILE[1]['newfilename'] = r.NewValue.Entity_POA_Doc
            this.ELEMENT_DATA_FILE[1]['fileExists1'] = true

          }
          else {
            this.ELEMENT_DATA_FILE[1]['newfilename'] = ""
            this.ELEMENT_DATA_FILE[1]['fileExists1'] = false

          }


          if (r.NewValue.Entity_GST_Doc != null && r.NewValue.Entity_GST_Doc != "") {
            this.ELEMENT_DATA_FILE[2]['newfilename'] = r.NewValue.Entity_GST_Doc
            this.ELEMENT_DATA_FILE[2]['fileExists1'] = true

          }
          else {
            this.ELEMENT_DATA_FILE[2]['newfilename'] = ""
            this.ELEMENT_DATA_FILE[2]['fileExists1'] = false

          }



          if (r.NewValue.Entity_SEBI_Doc != null && r.NewValue.Entity_SEBI_Doc != "") {
            this.ELEMENT_DATA_FILE[3]['newfilename'] = r.NewValue.Entity_SEBI_Doc
            this.ELEMENT_DATA_FILE[3]['fileExists1'] = true

          }
          else {
            this.ELEMENT_DATA_FILE[3]['newfilename'] = ""
            this.ELEMENT_DATA_FILE[3]['fileExists1'] = false

          }


          if (r.NewValue.Entity_Other_Doc != null && r.NewValue.Entity_Other_Doc != "") {
            this.ELEMENT_DATA_FILE[4]['newfilename'] = r.NewValue.Entity_Other_Doc
            this.ELEMENT_DATA_FILE[4]['fileExists1'] = true

          }
          else {
            this.ELEMENT_DATA_FILE[4]['newfilename'] = ""
            this.ELEMENT_DATA_FILE[4]['fileExists1'] = false

          }

          if (r.NewValue.Entity_Other_Doc1 != null && r.NewValue.Entity_Other_Doc1 != "") {
            this.ELEMENT_DATA_FILE[5]['newfilename'] = r.NewValue.Entity_Other_Doc1
            this.ELEMENT_DATA_FILE[5]['fileExists1'] = true

          }
          else {
            this.ELEMENT_DATA_FILE[5]['newfilename'] = ""
            this.ELEMENT_DATA_FILE[5]['fileExists1'] = false

          }


          this.entityForm.controls['urn_no'].setValue(this.entityRefNo);



          if (this.reqtype == "serviceLogs") {
            this.entityForm.controls['request_type'].setValue("Profile Modification");
          }

          else if (this.reqtype == "newRegistration") {
            this.entityForm.controls['request_type'].setValue("New Registration");
          }

          var approvedTS = ''

          var rejectTS = ''
          if ((r.OldValue.Entity_Status == "A" || r.OldValue.Entity_Status == "C") && r.E_Approve_Date != null && r.E_Approve_Time != null)
            approvedTS = r.E_Approve_Date + " " + r.E_Approve_Time

          else if (r.OldValue.Entity_Status == "R")
            rejectTS = r.E_Approve_Date + " " + r.E_Approve_Time
          else {
            rejectTS = "";
            approvedTS = " "
          }

          this.entityForm.controls['creation_timestamp'].setValue(moment(new Date(r.oldDate)).tz('Asia/Kolkata').format('LLL'));

          //   this.entityForm.controls['creation_timestamp'].setValue(moment(r.oldDate).tz('Asia/Kolkata').format('LLL')); // DD-MM-YYYY HH:mm

          this.entityForm.controls['assigned_timestamp'].setValue(moment(r.updatedAt).tz('Asia/Kolkata').format('LLL'));




          this.ELEMENT_DATA[0]['existing_detail'] = r.OldValue.Entity_ID;

          if (r.OldValue.Entity_Creator != null && r.OldValue.Entity_Creator != '')
            this.ELEMENT_DATA[1]['existing_detail'] = r.OldValue.Entity_Creator.toUpperCase();

          if (r.OldValue.Entity_Class != '' && r.OldValue.Entity_Class != null)
            this.ELEMENT_DATA[2]['existing_detail'] = eclass[r.OldValue.Entity_Class]
          this.ELEMENT_DATA[3]['existing_detail'] = r.OldValue.E_Org_Name;
          this.ELEMENT_DATA[4]['existing_detail'] = varEClass[r.OldValue.E_Org_Type];

          if (r.OldValue.POI != "" && r.OldValue.POI != null)
            this.ELEMENT_DATA[5]['existing_detail'] = this.Pan(r.OldValue.POI);
          if (r.OldValue.Entity_ID != null && r.OldValue.Entity_ID != '' && (r.OldValue.Entity_Status == "C" || r.OldValue.Entity_Status == "A"))
            this.ELEMENT_DATA[6]['existing_detail'] = "Active";
          else if (r.OldValue.Entity_ID != null && r.OldValue.Entity_ID != '' && (r.OldValue.Entity_Status == "I"))
            this.ELEMENT_DATA[6]['existing_detail'] = "Inactive";
          else if (r.OldValue.Entity_Status == "R")
            this.ELEMENT_DATA[6]['existing_detail'] = "Rejected";
          else if (r.OldValue.Entity_Status == "C")
            this.ELEMENT_DATA[6]['existing_detail'] = "Pending For Approval";
          else if (r.OldValue.Entity_Status == "M1" || r.OldValue.Entity_Status == "M2")
            this.ELEMENT_DATA[6]['existing_detail'] = "Sent For Modification";

          this.ELEMENT_DATA[7]['existing_detail'] = moment(r.OldValue.createdAt).tz('Asia/Kolkata').format('LLL');
          this.ELEMENT_DATA[8]['existing_detail'] = approvedTS;
          this.ELEMENT_DATA[9]['existing_detail'] = ""//moment(r.OldValue.updatedAt).tz('Asia/Kolkata').format('LLL');
          this.ELEMENT_DATA[10]['existing_detail'] = "Tata";
          this.ELEMENT_DATA[11]['existing_detail'] = r.NewValue.blacklist == 'true' ? 'True' : 'False'

          if (r.OldValue.Entity_Industry == "Others")
            this.ELEMENT_DATA[12]['existing_detail'] = "Others -" + r.OldValue.Entity_Industry_Other;
          else
            this.ELEMENT_DATA[12]['existing_detail'] = r.OldValue.Entity_Industry;

          if (r.OldValue.Entity_Sector == "Others")
            this.ELEMENT_DATA[13]['existing_detail'] = "Others -" + r.OldValue.Entity_Sector_Other;
          else
            this.ELEMENT_DATA[13]['existing_detail'] = r.OldValue.Entity_Sector;


          this.ELEMENT_DATA[14]['existing_detail'] = r.OldValue.Entity_AuthSignName;
          this.ELEMENT_DATA[15]['existing_detail'] = r.OldValue.Entity_EmailID;
          this.ELEMENT_DATA[16]['existing_detail'] = r.OldValue.Entity_Mobile_No;
          this.ELEMENT_DATA[17]['existing_detail'] = r.OldValue.Entity_Addr;
          this.ELEMENT_DATA[18]['existing_detail'] = r.OldValue.Entity_Addr1;
          this.ELEMENT_DATA[19]['existing_detail'] = r.OldValue.Entity_Addr2;

          this.ELEMENT_DATA[20]['existing_detail'] = r.OldValue.Entity_Landmark == "null" ? '' : r.OldValue.Entity_Landmark;

          this.ELEMENT_DATA[21]['existing_detail'] = r.OldValue.Entity_Country == "null" ? '' : r.OldValue.Entity_Country;

          this.ELEMENT_DATA[22]['existing_detail'] = r.OldValue.Entity_State == "null" ? '' : r.OldValue.Entity_State;
          this.ELEMENT_DATA[23]['existing_detail'] = r.OldValue.Entity_City == "null" ? '' : r.OldValue.Entity_City;
          this.ELEMENT_DATA[24]['existing_detail'] = r.OldValue.Entity_Pincode;
          this.ELEMENT_DATA[25]['existing_detail'] = r.OldValue.POI_Type;
          this.ELEMENT_DATA[26]['existing_detail'] = r.OldValue.POA;
          this.ELEMENT_DATA[27]['existing_detail'] = r.OldValue.Entity_GST_Id;
          this.ELEMENT_DATA[28]['existing_detail'] = r.OldValue.Other_Doc_Name;


          if (this.reqtype == "serviceLogs") {
            this.ELEMENT_DATA[29]['existing_detail'] = "Registered";
          }
          else if (this.reqtype == "newRegistration") {
            if (r.OldValue.Entity_ID != null && r.OldValue.Entity_ID != '')
              this.ELEMENT_DATA[29]['existing_detail'] = "Registered";
            else
              this.ELEMENT_DATA[29]['existing_detail'] = "Not Registered";
          }




          this.ELEMENT_DATA[30]['existing_detail'] = r.OldValue.Entity_TM_Type == "null" ? '' : r.OldValue.Entity_TM_Type;
          this.ELEMENT_DATA[31]['existing_detail'] = rejectTS
          if (r.OldValue.E_Mod1_RequestAt != null && r.OldValue.E_Mod1_RequestAt != undefined)
            this.ELEMENT_DATA[32]['existing_detail'] = moment(r.OldValue.E_Mod1_RequestAt).tz('Asia/Kolkata').format('LLL');
          else
            this.ELEMENT_DATA[32]['existing_detail'] = ""


          //         var newDataObject=r.NewValue;
          // var newValueArray=[newDataObject.Entity_ID,]
          // for(var i=0;i<29;i++){

          //   this.ELEMENT_DATA[i]['existing_details'] = r.NewValue.Entity_TM_Type;

          // }
          this.ELEMENT_DATA[0]['existing_details'] = r.NewValue.Entity_ID;
          if (r.NewValue.Entity_Creator != null && r.NewValue.Entity_Creator != '')
            this.ELEMENT_DATA[1]['existing_details'] = r.NewValue.Entity_Creator.toUpperCase();

          if (r.NewValue.Entity_Class != '' && r.NewValue.Entity_Class != null)
            this.ELEMENT_DATA[2]['existing_detail'] = eclass[r.NewValue.Entity_Class]

          this.ELEMENT_DATA[3]['existing_details'] = r.NewValue.E_Org_Name;
          if (r.NewValue.E_Org_Type != '' && r.NewValue.E_Org_Type != null)
            this.ELEMENT_DATA[4]['existing_details'] = varEClass[r.NewValue.E_Org_Type];



          if (r.NewValue.POI != null && r.NewValue.POI != '')
            this.ELEMENT_DATA[5]['existing_details'] = this.Pan(r.NewValue.POI);

          if (r.NewValue.Entity_ID != null && r.NewValue.Entity_ID != '' && (r.NewValue.Entity_Status == "C" || r.v.Entity_Status == "A"))
            this.ELEMENT_DATA[6]['existing_details'] = "Active";
          else if (r.NewValue.Entity_ID != null && r.NewValue.Entity_ID != '' && (r.NewValue.Entity_Status == "I"))
            this.ELEMENT_DATA[6]['existing_details'] = "Inactive";
          else if (r.NewValue.Entity_Status == "R")
            this.ELEMENT_DATA[6]['existing_details'] = "Rejected";
          else if (r.NewValue.Entity_Status == "C")
            this.ELEMENT_DATA[6]['existing_details'] = "Pending For Approval";
          else if (r.NewValue.Entity_Status == "M1" || r.NewValue.Entity_Status == "M2")
            this.ELEMENT_DATA[6]['existing_details'] = "Sent For Modification";

          this.ELEMENT_DATA[7]['existing_details'] = ""//moment(r.createdAt).tz('Asia/Kolkata').format('LLL');
          this.ELEMENT_DATA[8]['existing_details'] = "" //approvedTS;
          this.ELEMENT_DATA[9]['existing_details'] = ""//moment(r.updatedAt).tz('Asia/Kolkata').format('LLL');
          this.ELEMENT_DATA[10]['existing_details'] = "Tata";
          this.ELEMENT_DATA[11]['existing_details'] = r.NewValue.blacklist == 'true' ? 'True' : 'False'

          if (r.NewValue.Entity_Industry == "Others")
            this.ELEMENT_DATA[12]['existing_details'] = "Others -" + r.NewValue.Entity_Industry_Other;
          else
            this.ELEMENT_DATA[12]['existing_details'] = r.NewValue.Entity_Industry;

          if (r.NewValue.Entity_Sector == "Others")
            this.ELEMENT_DATA[13]['existing_details'] = "Others -" + r.NewValue.Entity_Sector_Other;
          else
            this.ELEMENT_DATA[13]['existing_details'] = r.NewValue.Entity_Sector;


          this.ELEMENT_DATA[14]['existing_details'] = r.NewValue.Entity_AuthSignName;
          this.ELEMENT_DATA[15]['existing_details'] = r.NewValue.Entity_EmailID;
          this.ELEMENT_DATA[16]['existing_details'] = r.NewValue.Entity_Mobile_No;
          this.ELEMENT_DATA[17]['existing_details'] = r.NewValue.Entity_Addr;

          this.ELEMENT_DATA[18]['existing_details'] = r.NewValue.Entity_Addr1;
          this.ELEMENT_DATA[19]['existing_details'] = r.NewValue.Entity_Addr2;
          this.ELEMENT_DATA[20]['existing_details'] = r.NewValue.Entity_Landmark == "null" ? '' : r.NewValue.Entity_Landmark;

          this.ELEMENT_DATA[21]['existing_details'] = r.NewValue.Entity_Country == "null" ? '' : r.NewValue.Entity_Country;

          this.ELEMENT_DATA[22]['existing_details'] = r.NewValue.Entity_State == "null" ? '' : r.NewValue.Entity_State;
          this.ELEMENT_DATA[23]['existing_details'] = r.NewValue.Entity_City == "null" ? '' : r.NewValue.Entity_City;
          this.ELEMENT_DATA[24]['existing_details'] = r.NewValue.Entity_Pincode;
          this.ELEMENT_DATA[25]['existing_details'] = r.NewValue.POI_Type;
          this.ELEMENT_DATA[26]['existing_details'] = r.NewValue.POA;
          this.ELEMENT_DATA[27]['existing_details'] = r.NewValue.Entity_GST_Id;
          this.ELEMENT_DATA[28]['existing_details'] = r.NewValue.Other_Doc_Name;


          if (this.reqtype == "serviceLogs") {
            this.ELEMENT_DATA[29]['existing_details'] = "Registered";
          }
          else if (this.reqtype == "newRegistration") {
            if (r.NewValue.Entity_ID != null && r.NewValue.Entity_ID != '')
              this.ELEMENT_DATA[29]['existing_details'] = "Registered";
            else
              this.ELEMENT_DATA[29]['existing_details'] = "Not Registered";
          }





          this.ELEMENT_DATA[30]['existing_details'] = r.NewValue.Entity_TM_Type == "null" ? '' : r.NewValue.Entity_TM_Type;
          this.ELEMENT_DATA[31]['existing_details'] = rejectTS
          if (r.OldValue.E_Mod2_RequestAt != null && r.OldValue.E_Mod2_RequestAt != undefined)
            this.ELEMENT_DATA[32]['existing_details'] = moment(r.OldValue.E_Mod2_RequestAt).tz('Asia/Kolkata').format('LLL');
          else
            this.ELEMENT_DATA[32]['existing_details'] = ""





        }
        else {
          this.$modal.errorModal({
            title: 'Entity Edit Log',
            msg: 'The entity has never been sent for modification'
          });
          // this.router.navigateByUrl('/entity-report')
        }
      })
  }
  download(file1, filetype) {

    var data = {
      "Entity_Ref_No": this.entityRefNo,
      "Folder": filetype,
      "FileName": file1,
      "Entity_Class": this.response.Entity_Class

    }

    this.es.modifyFileDownload(data).subscribe(r => {

      this.downloadFile(r, file1);
      this.$modal.successModal({
        title: 'Entity Edit Log',
        msg: 'File has been downloaded Successfully'
      });
    })

  }
  private downloadFile(res: any, filename: string): void {
    const url = window.URL.createObjectURL(res);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }







}//end of export


export class ExampleDataSource extends DataSource<any> {

  private dataSubject = new BehaviorSubject<Element[]>([]);

  data() {
    return this.dataSubject.value;
    //  return this.dataSubject1.value;
  }

  update(data) {
    this.dataSubject.next(data);
  }

  constructor(data: any[]) {
    super();
    this.dataSubject.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Element[]> {
    return this.dataSubject;
  }

  disconnect() { }
}